import CompleteDropdown from "../../../shared/Dropdown/CompleteDropdown";
import IconBubble from "../../../shared/Dropdown/IconBubble";
import { Dropdown } from "react-bootstrap";
import { faRecycle, faPaperPlane, faDisplay, faShare } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

export default function TimelinePostMenu({
  post,
  onDelete,
  onPublish,
  onVariants,
  onTeleprompter,
  onShare,
}) {
  const { t } = useTranslation();

  return (
    <CompleteDropdown deleteAction={() => onDelete?.(post)}>
      <Dropdown.Item onClick={() => onVariants?.(post)} className="d-flex align-items-center">
        <IconBubble icon={faRecycle} bg="rgba(81,210,140,0.12)" color="#2e9e65" />
        {t("Backend.Post.Variants.Create")}
      </Dropdown.Item>

      <Dropdown.Item onClick={() => onTeleprompter?.(post)} className="d-flex align-items-center">
        <IconBubble icon={faDisplay} bg="rgba(86,74,177,0.12)" color="#564ab1" />
        {t("Backend.Post.Teleprompter.NavigationTitle")}
      </Dropdown.Item>

      {(post?.status === "ready" || post?.status === "scheduled" || post?.status === "published") && (
        <Dropdown.Item onClick={() => onPublish?.(post)} className="d-flex align-items-center">
          <IconBubble icon={faPaperPlane} bg="rgba(3,142,220,0.12)" color="#038edc" />
          {t("Backend.Post.Publish")}
        </Dropdown.Item>
      )}

      <Dropdown.Item onClick={() => onShare?.(post)} className="d-flex align-items-center">
        <IconBubble icon={faShare} bg="rgba(247,204,83,0.15)" color="#b8880a" />
        {t("Backend.Post.ShareInGroup")}
      </Dropdown.Item>
    </CompleteDropdown>
  );
}
